<div class="app-alert display-none"
     [ngClass]="{'display-flex': appAlert.popupElements.length > 0}"
     *ngIf="appAlert.popupElements.length > 0">
    <div class="app-alert__box">
        <div class="app-alert__item bg-light box-shadow"
             *ngFor="let item of appAlert.popupElements; let key = index">
            <old-alert *ngIf="item.url === 'old-alert'" [item]="item"
                       [key]="key" data-testid="app-old-alert">
            </old-alert>

            <simple-message *ngIf="item.url === 'simple-message'" [item]="item" [key]="key"></simple-message>
            <popups-policy *ngIf="item.url === 'policy'"  [key]="key" ></popups-policy>
            <app-user-information *ngIf="item.url === 'user-information'" [item]="item" [key]="key"></app-user-information>

            <regulations-pl *ngIf="item.url === 'regulations_pl'"></regulations-pl>
            <regulations-en *ngIf="item.url === 'regulations_en'"></regulations-en>
            <regulations-de *ngIf="item.url === 'regulations_de'"></regulations-de>

            <regulations-kolton-pl *ngIf="item.url === 'regulations_kolton_pl'"></regulations-kolton-pl>
            <regulations-kolton-en *ngIf="item.url === 'regulations_kolton_en'"></regulations-kolton-en>

            <general-policy-pl *ngIf="item.url === 'general_policy_pl'"></general-policy-pl>
            <general-policy-en *ngIf="item.url === 'general_policy_en'"></general-policy-en>

            <policy-pl *ngIf="item.url === 'policy_pl'"></policy-pl>
            <policy-en *ngIf="item.url === 'policy_en'"></policy-en>
            <policy-de *ngIf="item.url === 'policy_de'"></policy-de>

            <policy-kolton-pl *ngIf="item.url === 'policy_kolton_pl'"></policy-kolton-pl>
            <policy-kolton-en *ngIf="item.url === 'policy_kolton_en'"></policy-kolton-en>

            <regulations-serwis24 *ngIf="item.url === 'regulations_rules_service24'"></regulations-serwis24>
        </div>
    </div>
</div>

@if (appAlert.alertDialog) {
    <alert-dialog></alert-dialog>
}
@if(appAlert.confirmDialog) {
    <confirm-dialog></confirm-dialog>
}
@if(appAlert.progressBarMessage) {
    <progress-bar></progress-bar>
}
